import { __awaiter } from '../../../_virtual/_tslib.js';
import EventEmitter from 'eventemitter3';
import { logger } from '@dynamic-labs/wallet-connector-core';
import { createEmailMagicWalletConnector } from '../EmailMagicWalletConnector/EmailMagicWalletConnector.js';
import '@magic-ext/oauth';

const createEmailOTPMagicWalletConnector = (ChainMagicConnector) => class EmailOTPMagicWalletConnector extends createEmailMagicWalletConnector(ChainMagicConnector) {
    constructor() {
        super(...arguments);
        this.name = 'Magic Email OTP';
        this.magicPromiSessionEventEmitter = new EventEmitter();
    }
    cancelLogIn() {
        var _a;
        (_a = this._handle) === null || _a === void 0 ? void 0 : _a.emit('cancel');
    }
    retryOneTimePassword() {
        return __awaiter(this, void 0, void 0, function* () {
            const { email } = this;
            if (!email)
                return;
            return this.sendOTP(email);
        });
    }
    verifyOneTimePassword(otp) {
        return __awaiter(this, void 0, void 0, function* () {
            const handle = this._handle;
            const invalidOTPError = new Error('Please double check your code and try again');
            if (!handle) {
                throw new Error('Login with email OTP before verifying');
            }
            return new Promise((resolve, reject) => {
                handle
                    .on('done', () => resolve(true))
                    .on('invalid-email-otp', () => reject(invalidOTPError))
                    .on('error', reject)
                    .catch(reject)
                    .emit('verify-email-otp', otp);
            }).then((result) => __awaiter(this, void 0, void 0, function* () {
                yield this.getAndCacheWalletAddress();
                return result;
            }));
        });
    }
    sendOTP(email) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const client = this.magicClient.getClient();
            (_a = this._handle) === null || _a === void 0 ? void 0 : _a.emit('cancel');
            try {
                yield this._handle;
            }
            catch (err) {
                logger.debug(err);
            }
            this._handle = client.auth.loginWithEmailOTP({
                email,
                showUI: false,
            });
            this._handle
                .then((token) => {
                this.magicPromiSessionEventEmitter.emit('token', token);
            })
                .catch((err) => {
                /**
                 * Magic will throw a cancelled error if a new OTP is requested.
                 * This check is to prevent the error from being emitted to the
                 * SDK and redirect the user to the wallets list page.
                 */
                if (isCancelledError(err)) {
                    logger.debug(err);
                    return;
                }
                this.magicPromiSessionEventEmitter.emit('error', err);
            });
        });
    }
    loginWithMagic() {
        return __awaiter(this, void 0, void 0, function* () {
            const user = yield this.getUserMetadata();
            if (user && user.publicAddress) {
                this.setEmail(user === null || user === void 0 ? void 0 : user.email);
                return user.publicAddress;
            }
            const { email } = this;
            if (!email)
                return null;
            this.sendOTP(email);
            return new Promise((resolve, reject) => {
                this.magicPromiSessionEventEmitter.once('token', resolve);
                this.magicPromiSessionEventEmitter.once('error', reject);
            });
        });
    }
};
const hasProperty = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
const MAGIC_SDK_GENERAL_ERROR_CODE = -32603;
const isCancelledError = (err) => {
    if (hasProperty(err, 'code') &&
        err.code !== MAGIC_SDK_GENERAL_ERROR_CODE) {
        return false;
    }
    if (hasProperty(err, 'message') &&
        err.message.includes('Request has been cancelled')) {
        return true;
    }
    return false;
};

export { createEmailOTPMagicWalletConnector, isCancelledError };
